import { CircularProgress, LinearProgress } from "@mui/material";
import useScreenDimensions from "../hooks/useScreenDimensions";
import { useEffect, useState } from "react";

export const Loading = ({
  isComplete,
  completeText,
  loadingText,
  loadingBar,
  showLoading,
}: {
  isComplete?: boolean;
  completeText?: string;
  loadingText?: string;
  loadingBar?: boolean;
  showLoading: boolean;
}) => {
  const { width, height } = useScreenDimensions();

  const [progress, setProgress] = useState<number>(15);

  useEffect(() => {
    setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress < 95) {
          return oldProgress + 2;
        } else {
          return oldProgress;
        }
      });
    }, 400);
  }, []);

  return (
    <div
      style={{
        width,
        height,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img src={"/logoForLoading.png"} />
      {showLoading ? (
        <>
          {!isComplete ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {loadingText?.length && !loadingBar ? (
                <div style={{ marginRight: "1rem" }}>{loadingText}</div>
              ) : (
                ""
              )}
              {loadingBar ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "1rem",
                  }}
                >
                  <div>Your Video Is Uploading.</div> <div>Please Do Not Close This Tab</div>
                  <LinearProgress
                    variant="determinate"
                    value={progress}
                    sx={{
                      height: 8,
                      borderRadius: 4,
                      backgroundColor: "#C84630",
                      "& .MuiLinearProgress-bar": {
                        backgroundColor: "#2EB3C8",
                      },
                      width: "15rem",
                    }}
                  />
                </div>
              ) : (
                <CircularProgress />
              )}
            </div>
          ) : (
            completeText
          )}{" "}
        </>
      ) : null}
    </div>
  );
};
